import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core';
import { ValidatorForm } from 'react-material-ui-form-validator';
import Note from '../../UI/Note';
import { InfoSharp } from '@material-ui/icons';
import { pasarErrorEvolucion } from '../../../../actions/hce/hceActions';

const useStyles = makeStyles({
  hoverObservacionesOK: {
    backgroundColor: '#eaece5',
    '&:hover': {
      backgroundColor: '#FFFF99',
      cursor: 'pointer',
    },
  },
  hoverObservacionesFinalizado: {
    backgroundColor: '#f18973',
    '&:hover': {
      backgroundColor: '#f18973',
      cursor: 'pointer',
    },
  },
});

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
};

export const ModalEvolucionesProblemas = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { problema } = props;
  // const [tituloModal, setTituloModal] = useState('');
  // const [openModalInfo, setOpenModalInfo] = useState(false);
  // const [info, setInfo] = useState(null);
  const { evoluciones } = useSelector((state) => state.hce);

  const onSubmitHandler = () => {};

  const pasarError = (evolucion) => {
    const datos = {
      idEvolucion: evolucion.id,
      idEfectorRedPasadoError: evolucion.idEfectorRed,
    };
    dispatch(pasarErrorEvolucion(datos, evolucion.idProblemaPaciente));
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={props.open}
        onClose={props.close}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>{props.titulo}</DialogTitle>
        <DialogContent
          style={{ overflowY: 'auto', maxHeight: '40vh', maxWidth: '100vw' }}
        >
          <ValidatorForm onSubmit={onSubmitHandler}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ paddingLeft: 16 }}
              >
                {Array.isArray(evoluciones) && evoluciones?.length > 0 ? (
                  <List>
                    {evoluciones.map((evolucion) => (
                      <ListItem
                        key={evolucion.id.toString()}
                        className={
                          evolucion.pasadoAError === null
                            ? classes.hoverObservacionesOK
                            : classes.hoverObservacionesFinalizado
                        }
                      >
                        <ListItemAvatar>
                          <Note />
                        </ListItemAvatar>
                        <ListItemText
                          primary={evolucion.evolucion}
                          secondary={`${new Date(
                            evolucion.fechaCarga,
                          ).toLocaleString('es', optionsfecha)} -- Prof.: ${
                            evolucion.nombreMedico
                          } - ${evolucion.descripcionEspecialidad} `}
                        />
                        {evolucion.pasadoAError === null && props.hce &&
                        problema.fechaFinalizado === null ? (
                          <ListItemSecondaryAction>
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={() => pasarError(evolucion)}
                            >
                              <Typography
                                style={{
                                  fontSize: '1.1rem',
                                  fontStyle: 'italic',
                                  marginBottom: '1rem',
                                }}
                              >
                                Pasar a Error
                              </Typography>
                            </IconButton>
                          </ListItemSecondaryAction>
                        ) : (
                          <ListItemSecondaryAction>
                            {evolucion.pasadoAError !== null && (
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => {
                                  // setOpenModalInfo(true);
                                  // setInfo(evolucion);
                                  //setTituloModal('Información');
                                }}
                              >
                                <Typography
                                  style={{
                                    fontSize: '1.1rem',
                                    fontStyle: 'italic',
                                    marginTop: '0.5rem',
                                    marginRight: '1rem',
                                  }}
                                >
                                  <InfoSharp />
                                </Typography>
                              </IconButton>
                            )}
                          </ListItemSecondaryAction>
                        )}
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography
                    style={{
                      fontSize: '1.1rem',
                      fontStyle: 'italic',
                      marginBottom: '1rem',
                    }}
                  >
                    No hay Evoluciones Ingresadas
                  </Typography>
                )}
              </Grid>
            </Grid>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
